import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=fc3be9fe&scoped=true&"
import script from "./AppView.vue?vue&type=script&lang=js&"
export * from "./AppView.vue?vue&type=script&lang=js&"
import style0 from "./AppView.vue?vue&type=style&index=0&id=fc3be9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3be9fe",
  null
  
)

export default component.exports